<template lang="pug">
.users-guest-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .mb-1 {{ $t('usersGuestCardTable.name') }}: {{ item.name }}
      .mb-1 {{ $t('usersGuestCardTable.email') }}: {{ item.email }}
      .mb-1 {{ $t('usersGuestCardTable.userSince') }}: {{ item.joined_at | dateTime }}
      .mb-1.profile
        icon.profile-icon(name='user-shield')(v-if='item.is_owner === true')
        icon.profile-icon(name='user')(v-else)
        |
        span.owner__organization(v-if='item.is_owner === true') {{ $t('usersGuestCardTable.owner') }}
        span(v-else) {{ $t('usersGuestCardTable.user') }}
      .mb-0
        button(
          @click.stop='openSetOwnerModal(item)'
          v-if='item.is_owner === true && item.id !== $root.user.id'
          v-tooltip:bottom='$t("usersGuestCardTable.removeOwner")'
        )
          icon(name='user-shield')
        button(
          disabled
          v-if='item.is_owner === true && item.id === $root.user.id'
          v-tooltip:bottom='$t("usersGuestCardTable.removeOwner")'
        )
          icon(name='user-shield')
        button(
          @click.stop='openSetOwnerModal(item)'
          v-if='!item.is_owner'
          v-tooltip:bottom='$t("usersGuestCardTable.makeOwner")'
        )
          icon(name='user-shield')
        button.btn--delete-user(
          @click.stop='openDeleteUserModal(item.id)'
          data-bs-target='#delete-user-modal'
          v-if='!item.is_owner'
          v-tooltip:bottom='$t("usersGuestCardTable.deleteUser")'
        )
          icon.icon--canceled(name='trash-can')
    template(v-slot:table-head)
      th(style='width: 30%') {{ $t('usersGuestCardTable.name') }}
      th(style='width: 30%') {{ $t('usersGuestCardTable.email') }}
      th(style='width: 15%') {{ $t('usersGuestCardTable.userSince') }}
      th(style='width: 10%') {{ $t('usersGuestCardTable.profile') }}
      th(style='width: 15%')
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      td {{ item.name }}
      td {{ item.email }}
      td {{ item.joined_at | dateTime }}
      td.profile
        icon.profile-icon(name='user-shield')(v-if='item.is_owner === true')
        icon.profile-icon(name='user')(v-else)
        |
        span.owner__organization(v-if='item.is_owner === true') {{ $t('usersGuestCardTable.owner') }}
        span(v-else) {{ $t('usersGuestCardTable.user') }}
      td
        .text-end
          button(
            @click.stop='openSetOwnerModal(item)'
            v-if='item.is_owner === true && item.id !== $root.user.id'
            v-tooltip:bottom='$t("usersGuestCardTable.removeOwner")'
          )
            icon(name='user-shield')
          button(
            disabled
            v-if='item.is_owner === true && item.id === $root.user.id'
            v-tooltip:bottom='$t("usersGuestCardTable.removeOwner")'
          )
            icon(name='user-shield')
          button(
            @click.stop='openSetOwnerModal(item)'
            v-if='!item.is_owner'
            v-tooltip:bottom='$t("usersGuestCardTable.makeOwner")'
          )
            icon(name='user-shield')
          button(
            @click.stop='openDeleteUserModal(item.id)'
            data-bs-target='#delete-user-modal'
            v-if='!item.is_owner'
            v-tooltip:bottom='$t("usersGuestCardTable.deleteUser")'
          )
            icon.icon--canceled(name='trash-can')
  delete-user-modal(
    :user-id='this.selectedUserId'
    @refresh='$emit("item-deleted", selectedUserId)'
    ref='deleteUserModal'
  )
  set-owner-user-modal(
    :is-owner='selectedUserIsOwner'
    :user-id='selectedOwnerUserId'
    @refresh='$emit("item-updated")'
    ref='setOwnerModal'
  )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import DeleteUserModal from '@/modules/account/components/organisms/modals/DeleteUserModal.vue';
import SetOwnerUserModal from '@/modules/business/components/organisms/modals/SetOwnerUserModal.vue';
import CardTable from '@/ui/organisms/CardTable.vue';

export default {
  name: 'UsersGuestCardTable',
  components: {
    Icon,
    DeleteUserModal,
    SetOwnerUserModal,
    CardTable,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedUserId: '',
      selectedOwnerUserId: '',
      selectedUserIsOwner: false,
    };
  },
  methods: {
    openDeleteUserModal(id) {
      this.selectUserToSendModal(id);
      this.$refs.deleteUserModal.$refs.modal.open();
    },
    selectUserToSendModal(user) {
      this.selectedUserId = user;
    },
    openSetOwnerModal(user) {
      this.selectedOwnerUserId = user.id;
      this.selectedUserIsOwner = user.is_owner === true;
      this.$refs.setOwnerModal.$refs.modal.open();
    },
  },
};
</script>

<style lang="stylus">
.users-guest-card-table
  .btn-reinvite-user
    i
      color: #013D52;
  .btn--delete-user
    position: absolute
    top: 0.5rem
    right: 0.5rem
  .owner__organization
    font-weight: 600
    color: #013D52
  .profile
    span
      position: absolute
      top: 0.7rem
  .profile-icon
    margin-right: 0.25rem
    vertical-align: middle
    top: 0.5rem
</style>
